import { SvgIcon } from '@mui/material';
import { ResponsiveButton } from 'components/buttons';
import { Icons } from 'greener-ui-library';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

export default function Blueprints() {
  const { t } = useTranslation();

  return (
    <ResponsiveButton
      data-testid="blueprints-navigation"
      color="inherit"
      component={RouterLink}
      to="/solutions"
      breakpoint="sm"
      icon={() => (
        <SvgIcon sx={{ fontSize: 24 }}>
          <Icons.Solution />
        </SvgIcon>
      )}
    >
      {t('entities:blueprint.namePlural')}
    </ResponsiveButton>
  );
}
